import api from './axiosService';

export const salesApi = {
    getAll(params = {}) {
        return api.get('/sales', { params });
    },

    getMyShops(params = {}) {
        return api.get('/sales/my-shops', { params });
    },

    getById(salesId) {
        return api.get(`/sales/${salesId}`);
    },

    getByShop(shopId, params = {}) {
        return api.get(`/sales/shop/${shopId}`, { params });
    },

    getStatsByShop(shopId, params = {}) {
        return api.get(`/sales/shop/${shopId}/stats`, { params });
    },

    getBySeller(sellerId) {
        return api.get(`/sales/seller/${sellerId}`);
    },

    getByStock(stockId) {
        return api.get(`/sales/stock/${stockId}`);
    },

    getByDateRange(params = {}) {
        return api.get('/sales/by-date-range', { params });
    },

    getStats() {
        return api.get('/sales/stats');
    },

    export(params = {}) {
        return api.get('/sales/export', { params });
    },

    create(data) {
        return api.post('/sales', data);
    },

    update(salesId, data) {
        return api.put(`/sales/${salesId}`, data);
    },

    toggleStatus(salesId) {
        return api.patch(`/sales/${salesId}/toggle-status`);
    },

    bulkUpdateStatus(data) {
        return api.patch('/sales/bulk-status', data);
    },
};